import { EmailSignUpForm } from "@/components/email-sign-up-form";
import { ExternalLink } from "@/components/external-link";
import { externalUrls, routes } from "@/constants/url";
import { trackPixelReservedEvent } from "@/lib/track/pixel";
import { TrackingEvent } from "@/lib/track/track-event";
import { trackEvent } from "@/lib/track/track-event";
import { Typography } from "@backpac/monica";
import { Link, useNavigate } from "react-router";
import { SeparatorWithText } from "../components/separator-with-text";
import { SignInWithGoogleButton } from "../components/sign-in-with-google-button";

export function SignUpPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3 w-full">
        <Typography asChild size="xl" font="unbounded">
          <h1>Create your account</h1>
        </Typography>
        <div className="flex items-center gap-1">
          <Typography asChild size="xs" weight={500}>
            <span>Already have an account?</span>
          </Typography>
          <Typography asChild size="xs" weight={500} className="underline">
            <Link to={routes.AUTH.signin}>Sign in</Link>
          </Typography>
        </div>
      </div>

      <SignInWithGoogleButton text="Sign up with Google" />
      <SeparatorWithText>OR</SeparatorWithText>
      <EmailSignUpForm
        onSignupSuccess={(user) => {
          trackEvent(TrackingEvent.SignUp, {
            name: user.user_metadata.name,
            email: user.email,
            method: "email",
          });
          trackPixelReservedEvent("Lead");
          navigate(`${routes.AUTH.signupEmailVerify}?email=${encodeURIComponent(user?.email ?? "")}`);
        }}
        onSignInSuccess={(user) => {
          trackEvent(TrackingEvent.SignIn, {
            name: user.user_metadata.name,
            email: user.email,
            method: "email",
          });
          navigate(routes.WORKSPACE_NAVIGATOR.root, { replace: true });
        }}
      />

      <div className="flex flex-col items-center w-full justify-center text-center">
        <Typography asChild size="paragraphXs" color="textPrimary">
          <p>
            By using BackPac, you are agreeing to our
            <br />{" "}
            <ExternalLink to={externalUrls.TERMS_OF_SERVICE_URL} className="font-semibold underline">
              Terms of Service
            </ExternalLink>{" "}
            and{" "}
            <ExternalLink to={externalUrls.PRIVACY_POLICY_URL} className="font-semibold underline">
              Privacy Policy
            </ExternalLink>
          </p>
        </Typography>
      </div>
    </div>
  );
}
